import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getHwShipment = data => {
  return axios.request({
    url: "/finance/overseas/outbound",
    method: "post",
    data
  });
};

export const postRecalculate = data => {
  return axios.request({
    url: "/finance/overseas/outbound/recalculate",
    method: "post",
    data
  });
};

export const saveCreateBill = data => {
  return axios.request({
    url: "/finance/overseas/outbound/createBill",
    method: "post",
    data
  });
};

export const cancelHangBill = data => {
  return axios.request({
    url: `/finance/overseas/outbound/cancelAbnormal`,
    method: "post",
    data
  });
};

export const updateItemsType = data => {
  return axios.request({
    url: `/finance/overseas/outbound/changeOrderType`,
    method: "post",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/finance/overseas/outbound/updateWeightFinance",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};
